import { Calendar, Clock, TrendingUp, User } from 'lucide-react'
import { formatDate } from '@/utils/format-date'
import type { DashboardRecentActivity } from '@/hooks/dashboardDataTypes'

type Props = {
  activities: DashboardRecentActivity[]
}

const typeConfig: Record<string, { icon: typeof User; color: string; label: string }> = {
  lead_event: { icon: User, color: 'text-blue-500', label: 'Lead' },
  interaction: { icon: TrendingUp, color: 'text-purple-500', label: 'Negócio' },
  meeting: { icon: Calendar, color: 'text-emerald-500', label: 'Reunião' },
}

export function OperacaoRecentActivity({ activities }: Props) {
  return (
    <div className='rounded-2xl border border-[var(--border)] bg-[var(--bg-card)] p-4 shadow-sm sm:p-5'>
      <div className='mb-4 flex items-center gap-2'>
        <Clock size={16} className='text-accent' aria-hidden />
        <h3 className='text-sm font-bold uppercase tracking-widest text-text-primary'>
          Atividade recente
        </h3>
      </div>

      {!activities?.length ? (
        <p className='py-8 text-center text-sm text-text-muted'>Nenhuma atividade no período.</p>
      ) : (
        <ul className='space-y-2'>
          {activities.map((activity) => {
            const config = typeConfig[activity.type] ?? {
              icon: TrendingUp,
              color: 'text-text-muted',
              label: 'Atividade',
            }
            const Icon = config.icon

            return (
              <li
                key={activity.id}
                className='flex items-start gap-3 rounded-xl border border-[var(--border)] bg-[var(--bg-dark)]/15 px-3 py-2.5'
              >
                <div className='flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-[var(--border)] bg-[var(--bg-card)]'>
                  <Icon size={14} className={config.color} aria-hidden />
                </div>
                <div className='min-w-0 flex-1'>
                  <p className='truncate text-sm font-semibold text-text-primary'>
                    {activity.entityName}
                  </p>
                  <p className='truncate text-xs text-text-muted'>{activity.description}</p>
                </div>
                <div className='shrink-0 text-right'>
                  <p className='text-[10px] text-text-muted'>{formatDate(activity.createdAt)}</p>
                  <p className='text-[10px] font-bold uppercase tracking-wider text-text-muted/70'>
                    {config.label}
                  </p>
                </div>
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}
